import { createSlice } from '@reduxjs/toolkit'
import { gameClose, userLogin } from 'redux-store/thunk/auth.thunk'
import { fetchUserInformation, updateBalanceAsync } from 'redux-store/thunk/user.thunk'
import { getPayloadFromToken } from 'helpers/common.helpers'
import { plus, minus } from 'number-precision'
import { CURRENCY_SYMBOLS } from 'utils/constants/index'

const defaultAuthState = {
  creditWalletWaitQueue: [],
  creditDemoWalletWaitQueue: [],
  userInfo: null,
  userDetails: null,
  currencyId: null,
  currencyCode: null,
  isLoggedIn: false,
  showName: false,
  demoMode: false,
  demoWallet: { balance: 3000, currency: 'EUR' }
}

const authSlice = createSlice({
  name: 'authSlice',
  initialState: defaultAuthState,
  reducers: {
    appendCreditWalletWaitQueue: (state, action) => {
      return {
        ...state,
        creditWalletWaitQueue: [action.payload, ...state.creditWalletWaitQueue]
      }
    },
    updatePlinkoCreditWalletWaitQueue: (state, action) => {
      const { currentBetWinningAmount } = action.payload
      let _creditWalletWaitQueue = [...state.creditWalletWaitQueue]
      const { balance: currentBalance } = { ...state.userInfo.wallet }
      const _userInfoWallet = { ...state.userInfo.wallet, balance: plus(currentBalance, +currentBetWinningAmount) }
      // const _userInfoWallet = _creditWalletWaitQueue[_creditWalletWaitQueue.length - 1] ?? state.userInfo.wallet
      _creditWalletWaitQueue = _creditWalletWaitQueue?.slice(0, _creditWalletWaitQueue.length - 1)
      return {
        ...state,
        creditWalletWaitQueue: _creditWalletWaitQueue,
        userInfo: {
          ...state.userInfo,
          wallet: _userInfoWallet
        }
      }
    },
    updateCreditWalletWaitQueue: (state, action) => {
      let _creditWalletWaitQueue = [...state.creditWalletWaitQueue]
      const _userInfoWallet = _creditWalletWaitQueue[_creditWalletWaitQueue.length - 1] ?? state.userInfo.wallet
      _creditWalletWaitQueue = _creditWalletWaitQueue?.slice(0, _creditWalletWaitQueue.length - 1)
      return {
        ...state,
        creditWalletWaitQueue: _creditWalletWaitQueue,
        userInfo: {
          ...state.userInfo,
          wallet: _userInfoWallet
        }
      }
    },
    updateCreditDemoWalletWaitQueue: (state, action) => {
      let _creditDemoWalletWaitQueue = [...state.creditDemoWalletWaitQueue]
      const _newDemoWallet = _creditDemoWalletWaitQueue.pop() ?? state.demoWallet
      _creditDemoWalletWaitQueue = _creditDemoWalletWaitQueue?.slice(0, _creditDemoWalletWaitQueue.length - 1)
      return {
        ...state,
        creditDemoWalletWaitQueue: _creditDemoWalletWaitQueue,
        demoWallet: _newDemoWallet
      }
    },
    appendCreditDemoWalletWaitQueue: (state, action) => {
      return {
        ...state,
        creditDemoWalletWaitQueue: [action.payload, ...state.creditDemoWalletWaitQueue]
      }
    },
    setShowName: (state, action) => {
      return {
        ...state,
        showName: !state.showName
      }
    },
    setUserInfo: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        wallet: action.payload?.currency === state.userInfo.wallet?.currency ? action.payload : state.userInfo.wallet
      }
    }),
    setDemoMode: (state, action) => {
      return {
        ...state,
        demoMode: action.payload,
        currencyCode: state.demoWallet.currency
      }
    },
    setDemoWalletCurrency: (state, action) => ({
      ...state,
      currencyCode: action.payload.currencyCode,
      currencyId: action.payload?.currencyId,
      currencySymbol: CURRENCY_SYMBOLS?.[action.payload.currencyCode] || '$',
      demoWallet: { ...state.demoWallet, currency: action.payload.currencyCode },
      operatorId: action.payload?.operatorId
    }),
    updateDemoWalletBalance: (state, action) => {
      return {
        ...state,
        demoWallet: { ...state.demoWallet, balance: action.payload }
      }
    },
    updateDemoWalletBalanceForBetPlace: (state, action) => {
      const newBalance = (action.payload.operation === 'add') ? state.demoWallet.balance + Number(action.payload.amount) : state.demoWallet.balance - Number(action.payload.amount)

      return {
        ...state,
        demoWallet: { ...state.demoWallet, balance: newBalance }
      }
    },
    debitBalance: (state, action) => {
      const { balance: currentBalance } = { ...state.userInfo.wallet }
      const _userInfoWallet = { ...state.userInfo.wallet, balance: minus(currentBalance, +action?.payload) }
      return ({
        ...state,
        userInfo: {
          ...state.userInfo,
          wallet: _userInfoWallet
        }
      })
    },
    updateUserWallet: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        wallet: action.payload
      }
    })
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.fulfilled, (state, action) => {
        const { user, wallet, accessToken } = action.payload
        const payload = getPayloadFromToken(accessToken)
        const currencyId = payload?.currencyId
        const currencyCode = payload?.currencyCode
        return {
          ...state,
          currencyId,
          currencyCode,
          userInfo: { user, wallet },
          isLoggedIn: true
        }
      })
      .addCase(fetchUserInformation.fulfilled, (state, action) => {
        return {
          ...state,
          userDetails: action.payload
        }
      })
      .addCase(updateBalanceAsync.fulfilled, (state, action) => {
        if (state.userInfo?.wallet) {
          state.userInfo.wallet.balance = action.payload
        }
      })
      .addCase(gameClose.fulfilled, (state, action) => {
        return defaultAuthState
      })
  }
})

export const {
  setUserInfo, appendCreditWalletWaitQueue,
  updateCreditWalletWaitQueue, setShowName, appendCreditDemoWalletWaitQueue, updateCreditDemoWalletWaitQueue, updatePlinkoCreditWalletWaitQueue, debitBalance, updateUserWallet, setDemoMode, updateDemoWalletBalance, updateDemoWalletBalanceForBetPlace, setDemoWalletCurrency
} = authSlice.actions

export default authSlice.reducer
